<template>
    <div class="flex w-full flex-col rounded bg-ds-primary-100 px-7 py-2">
        <VerificationFullRow
            class="border-b-ds-primary-400"
            :indentationLevel="0"
            omit-error-list
        >
            <div class="text-xl font-bold text-content-primary">Overall Result</div>
            <template #check-result>
                <CheckStateResult
                    v-if="result.overallStatus"
                    class="text-sm text-xl font-bold"
                    :value="result.overallStatus"
                />
            </template>
        </VerificationFullRow>
        <VerificationFullRow
            :check-result="result.knownYourCustomer"
            :indentationLevel="0"
            omit-error-list
            >Know Your Customer (KYC)
        </VerificationFullRow>
        <VerificationFullRow
            :check-result="result.govIdAnalysis"
            :indentationLevel="0"
            omit-error-list
            >Government ID Analysis</VerificationFullRow
        >
        <VerificationFullRow
            v-if="selfieEnabled"
            :check-result="result.selfieVerification"
            :indentationLevel="0"
            omit-error-list
        >
            Selfie Verification
        </VerificationFullRow>
        <VerificationFullRow
            :indentationLevel="0"
            omit-error-list
        >
            IP Address information
            <template #check-result>
                <div
                    v-if="result.ipAddressAvailable"
                    class="bold text-sm font-semibold"
                >
                    Review Results
                </div>
                <div
                    v-else
                    class="bold text-sm font-semibold"
                >
                    Not Available
                </div>
            </template>
        </VerificationFullRow>
        <VerificationFullRow
            :indentationLevel="0"
            omit-error-list
            :with-divider="false"
        >
            Additional Information
            <template #check-result>
                <div class="bold text-sm font-semibold">Review Results</div>
            </template>
        </VerificationFullRow>
    </div>
</template>

<script lang="ts" setup>
import type { OverallResult } from '@/api/interfaces/identity-verification-report.api';
import CheckStateResult from '../common/CheckStateResult.vue';
import VerificationFullRow from '../common/VerificationFullRow.vue';

withDefaults(defineProps<{ result: OverallResult; selfieEnabled: boolean }>(), {
    selfieEnabled: false,
});
</script>
